import React, {
  useRef,
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import SearchPanel from "../../../../../widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import { ColumnConfig } from "@shared/components/Grid/types";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { menuInfo } from "@shared/type/CommonType";

interface Props {
  Menuprops: menuInfo;
}

const SN_TRA_NGO_REP_002 = forwardRef(({ Menuprops }: Props, ref) => {
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
  });
  const [columns, setColums] = useState<any>({
    grid1: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
  });
  const searchRef = useRef<any>(null);
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const today = new Date();
  const todayform = `${today.getFullYear()}${(today.getMonth() + 1)
    .toString()
    .padStart(2, "0")}${today.getDate().toString().padStart(2, "0")}`;
  const popDate = new Date();
  popDate.setDate(1);
  const firstDayOfMonth = `${popDate.getFullYear()}${(popDate.getMonth() + 1)
    .toString()
    .padStart(2, "0")}${popDate.getDate().toString().padStart(2, "0")}`;

  const { userInfo } = global();

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormData(rtn.formData);
        setFormControlData(rtn.formControlData);
        setColums({
          grid1: rtn.grid.grid1,
        });
      } catch (error) {}
    };
    fetchform();
  }, []);

  const onSearch = async () => {
    try {
      const param = {
        id: "sn_tra_ngo_rep_002_01",
        params: searchRef.current.getFormdata(),
      };

      const data: any = await fnGetDataSet(param);

      setDataSources({
        grid1: data[0],
      });
    } catch (error) {}
  };

  useImperativeHandle(ref, () => ({
    onSearch,
  }));
  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
      },
    }),
    [columns, dataSources]
  );
  return (
    <div className="h-full flex flex-col">
      <div>
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>
      <div className="flex-1">
        <SnGrid
          // Pros로 받은 Menuprops
          ref={gridRefs.current["grid1"]} // Grid Name
          columnConfig={grids.grid1.columns} // 컬럼 설정 전달
          rowData={grids.grid1.dataSource} // Datasource
          etcProps={{
            rowSelection: "multiple",
          }}
        />
      </div>
    </div>
  );
});

export default SN_TRA_NGO_REP_002;
